// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withIsVisible = require('client-v2/common/components/is-visible')
// Entry imports
const modalActions = require('./actions')
const AuthModal = require('./component-dumb')
const socialProviders = require('./providers')

function mapStateToProps(state) {
  const { authModal } = state
  if (!authModal || !authModal.isVisible) {
    return { isVisible: false }
  }
  return {
    errorProvider: authModal.errorProvider,
    errorType: authModal.errorType,
    hasAccount: authModal.hasAccount,
    isVisible: true,
    socialProviders
  }
}

const mapDispatchToProps = {
  onClose: modalActions.hide,
  onHasAccountToggle: modalActions.show,
  onSocialProviderAuth: modalActions.socialAuth
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    AuthModal
  )
)
